import { ref, computed, type Ref } from "vue";

export function useVerticalSlider(options: {
  min: Ref<number>;
  max: Ref<number>;
  thumbSize: number;
}) {
  const { min, max, thumbSize } = options;
  const value = ref(min.value);

  // 0~1 사이 퍼센트
  const percent = computed(() => {
    return Math.min(
      1,
      Math.max(0, (value.value - min.value) / (max.value - min.value))
    );
  });

  // H(px)를 주면 thumb bottom(px) 반환
  function thumbBottomPx(H: number) {
    return percent.value * (H - thumbSize);
  }

  // pointer Y 좌표 + DOMRect 로부터 value 갱신
  function updateFromY(y: number, rect: DOMRect) {
    const p = Math.min(1, Math.max(0, (rect.bottom - y) / rect.height));
    value.value = Math.round(min.value + p * (max.value - min.value));
  }

  return { value, thumbBottomPx, updateFromY };
}
